import { buildingSavingsProductService } from 'aem-libs-api/src/services/building-savings-product/v1/building-savings-product'
import { getConfig } from 'aem-libs-react-ts/src/utils/getConfig'

const config = getConfig()

export const burinkaApi = buildingSavingsProductService(config)
